export default {
  default: () => import("D:/word/qctsw-vue/packages/app/src/layouts/default.vue").then(m => m.default || m)
}